import type { ReadonlyJSONValue } from "@rocicorp/zero";
import type { ChatEntryWithSubTables } from "../../../shared/aiSdkMessages";
import type { IconName } from "../Icon";

function object(value: ReadonlyJSONValue | null | undefined) {
  return value && typeof value === "object" && !Array.isArray(value)
    ? (value as Record<string, ReadonlyJSONValue>)
    : null;
}

function string(value: ReadonlyJSONValue | undefined) {
  return typeof value === "string" ? value : null;
}

export function deriveChatOutputs(
  entries: readonly ChatEntryWithSubTables[]
): { executionId: string; fileName: string }[] {
  const seen = new Set<string>();
  const outputs: { executionId: string; fileName: string }[] = [];
  for (const entry of [...entries].reverse()) {
    if (entry.entryType !== "AssistantToolUse") continue;
    const toolCall = entry.toolCall;
    if (toolCall?.toolName !== "showExecutionOutput") continue;
    if (toolCall.completedAt == null || toolCall.isError) continue;
    const input = object(toolCall.input);
    const executionId = string(input?.executionId);
    const fileName = string(input?.fileName);
    if (!executionId || !fileName || seen.has(executionId)) continue;
    seen.add(executionId);
    outputs.push({ executionId, fileName });
  }
  return outputs;
}

export function iconForFileName(fileName: string): IconName {
  switch (fileName.split(".").pop()?.toLowerCase()) {
    case "pdf":
      return "file-scan";
    case "csv":
    case "tsv":
      return "table";
    case "db":
    case "sqlite":
      return "database";
    default:
      return "paperclip";
  }
}
